<template>
  <v-app class="pa-6">
    <HeaderComponent />
    <Sidebar />
    <v-btn
      color="primary"
      fixed
      bottom
      right
      fab
      href="https://software.space-registry.org"
      target="_blank"
    >
      <v-icon>mdi-arrow-top-right-bold-outline</v-icon>
    </v-btn>
    <v-main class="content scrollable" v-resize="onResize">
      <router-view />
      <!-- <Footer /> -->
    </v-main>
  </v-app>
</template>

<script>
  import HeaderComponent from '@/components/Layout/HeaderComponent'
  import Sidebar from '@/components/Layout/Sidebar'
  //   import Footer from '@/components/Layout/Footer'
  //import './Layout.scss';

  export default {
    methods: {
      onResize() {
        //64px is v-app-bar height in your case
        document.querySelector('.scrollable').style.height =
          window.innerHeight - 64 + 'px'
      }
    },
    components: { /* Footer, */ HeaderComponent, Sidebar }
  }
</script>
